import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";

interface IState {
  parentId: string | null;
  activePopover: string | null;
}

interface IActions {
  setParentId: (value: string | null) => void;
  setActivePopover: (value: string | null) => void;
  reset: () => void;
}

const initState: IState = {
  parentId: null,
  activePopover: null,
};

export const useAddElementStore = create<IState & IActions>((set, get) => ({
  ...initState,
  setParentId: (parentId) => set({ parentId }),
  setActivePopover: (activePopover) => set({ activePopover }),
  reset: () => set(initState),
}));

export const useAddElementStoreShallow = <U>(
  selector: (store: IState & IActions) => U,
) => {
  return useAddElementStore(useShallow(selector));
};
